import { SET_CURRENT_USER, SIGN_OUT } from "./actionTypes";

export const setCurrentUser = user => ({ type: SET_CURRENT_USER, user });
export const userSignOut = () => ({ type: SIGN_OUT });
